export const cookieObj = {
    name: '',
    username: '',
    type: '',
    token: '',
    clientId: '',
    userRole: '',
    clientName: '',
    profileImg: '',
    expiration: '',
    assetTypes:[],
    serviceTypes:[],
    resetPassword:'',
    bM_ACCESS_STATUS:'',
    defaultTab:'',
    devicechanged:""
    
}